import { memo } from 'react';

import { WorkspaceHeaderInformationDropdown } from '~/components/v2/components/workspace/workspace-header/ui2026/WorkspaceHeaderInformationDropdown';
import { WorkspaceHeaderInformationDropdown as LegacyWorkspaceHeaderInformationDropdown } from '~/components/v2/components/workspace/workspace-header/WorkspaceHeaderInformationDropdown';
import { WorkspaceHeaderInformationLogo } from '~/components/v2/components/workspace/workspace-header/WorkspaceHeaderInformationLogo';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export const WorkspaceHeaderInformation = memo(() => {
  const { ui2026 } = useTemporaryFeatureFlags();

  if (ui2026) {
    return (
      <div className="relative z-40 flex h-full w-max max-w-48 shrink-0 items-stretch overflow-hidden lg:max-w-80">
        <div className="peer flex h-full min-w-0 max-w-full items-stretch">
          <WorkspaceHeaderInformationDropdown />
        </div>
        {/*
          Matches the trigger chevron's rest→hover delta (`ml-1` + `w-3.5`) and collapses when
          that chevron grows. Key off the trigger peer, not this row: hovering the reserve
          itself must not collapse it while the chevron stays closed.
        */}
        <span
          aria-hidden
          className="ml-1 w-3.5 shrink-0 transition-[margin,width] peer-has-[:focus-visible]:ml-0 peer-has-[[data-state=open]]:ml-0 peer-has-[button:hover]:ml-0 peer-has-[:focus-visible]:w-0 peer-has-[[data-state=open]]:w-0 peer-has-[button:hover]:w-0"
        />
      </div>
    );
  }

  return (
    <div className="relative z-40 flex min-w-0 max-w-[var(--sidebar-width)] shrink items-center gap-1 px-4">
      <WorkspaceHeaderInformationLogo />
      <LegacyWorkspaceHeaderInformationDropdown />
    </div>
  );
});

WorkspaceHeaderInformation.displayName = 'WorkspaceHeaderInformation';
